import useUserPermission from "~/hooks/useUserPermission";
import { MANAGE_AGENTS } from "~/router/permissions";

export const useCanManageAIAgents = (): boolean => useUserPermission(MANAGE_AGENTS);
